import Axios from "axios";
import store from "@/store";
//Local route names 'must' start with _ underscore.
const localRoutesRaw = [
    {
        path: "/admin/groups",
        name: "_adminGroups",
        component: () => import("@/pages/admin/groups.vue"),
        meta: {
            title: "Groups Admin"
        }
    },
    {
        path: "/admin/promos",
        name: "_adminPromos",
        component: () => import("@/pages/admin/promos.vue"),
        meta: {
            title: "Promos Admin"
        }
    },
    {
        path: "/search",
        name: "_Search",
        component: () => import("@/pages/search.vue"),
        meta: {
            title: "Search"
        }
    },
    {
        path: "/mcl/assignments/my",
        name: "_AssignmentsMy",
        component: () => import("@/pages/mcl/assignments.vue"),
        props: { myAssignments: true },
        meta: {
            title: "My Assignments",
            hideDrawer: true
        }
    },
    {
        path: "/mcl/assignments/location",
        name: "_AssignmentsMyLocation",
        component: () => import("@/pages/mcl/assignments.vue"),
        props: { myLocation: true },
        meta: {
            title: "My Location Assignments",
            hideDrawer: true
        }
    },
    {
        path: "/mcl/assignments/all",
        name: "_AssignmentsAll",
        component: () => import("@/pages/mcl/assignments.vue"),
        props: true,
        meta: {
            title: "All Assignments",
            hideDrawer: true
        }
    },
    {
        path: "/mcl/assignments/:Id",
        name: "_assignmentDetail",
        component: () => import("@/pages/assignment/assignment.vue"),
        meta: {
            title: "Assignment Detail"
        }
    },
    {
        path: "/mcl/assignments/:Id/blf",
        name: "_assignmentBLF",
        component: () => import("@/pages/assignment/blf.vue"),
        meta: {
            title: "Leadership Consulting",
            hideDrawer: true
        }
    },
    {
        path: "/mcl/assignments/report",
        name: "_ReportsAssignments",
        component: () => import("@/pages/mcl/reports/assignments.vue"),
        props: true,
        meta: {
            title: "Advanced Assignment Search",
            hideDrawer: true
        }
    },
    {
        path: "/mcl/companies/my",
        name: "_CompaniesMy",
        component: () => import("@/pages/mcl/companies.vue"),
        props: { myCompanies: true },
        meta: {
            title: "My Companies",
            hideDrawer: true
        }
    },
    {
        path: "/mcl/companies/location",
        name: "_CompaniesMyLocation",
        component: () => import("@/pages/mcl/companies.vue"),
        props: { myLocation: true },
        meta: {
            title: "My Location Companies",
            hideDrawer: true
        }
    },
    {
        path: "/mcl/companies/all",
        name: "_Companies",
        component: () => import("@/pages/mcl/companies.vue"),
        props: true,
        meta: {
            title: "All Companies",
            hideDrawer: true
        }
    },
    {
        path: "/mcl/companies/:Id",
        name: "_companyDetail",
        component: () => import("@/pages/company/company.vue"),
        meta: {
            title: "Company Detail",
            hideFromNav: true
        }
    },
    {
        path: "/mcl/companies/:Id/admin",
        name: "_companyAdmin",
        component: () => import("@/pages/company/admin/admin.vue"),
        meta: {
            title: "Company Admin"
        }
    },
    {
        path: "/mcl/companies/report",
        name: "_ReportsCompanies",
        component: () => import("@/pages/mcl/reports/companies.vue"),
        props: true,
        meta: {
            title: "Advanced Company Search",
            hideDrawer: true
        }
    },
    {
        path: "/mcl/dashboard",
        name: "_Dashboard",
        component: () => import("@/pages/mcl/dashboard.vue"),
        props: true,
        meta: {
            title: "Dashboard"
        }
    },
    /*
        {
            path: "/mcl/reports/financial",
            name: "_ReportsFinancial",
            component: () => import("@/pages/mcl/reports/financial.vue"),
            meta: {
                title: "Financial Report",
                hideDrawer: true
            }
        },
    */
    {
        path: "/directory/licenses/report",
        name: "_ReportsLicenses",
        component: () => import("@/pages/mcl/reports/licenses.vue"),
        meta: {
            title: "License Report",
            hideDrawer: true
        }
    },
    {
        path: "/directory/boydenians",
        name: "_Boydenians",
        component: () => import("@/pages/directory/boydenians.vue"),
        meta: {
            title: "Boydenians",
            hideDrawer: true
        }
    },
    {
        path: "/directory/boydenians/:Id",
        name: "_partnerProfile",
        component: () => import("@/pages/profile/profile.vue"),
        meta: {
            title: "Boydenian"
        },
        props: route => ({
            userId: route.params.Id
        })
    },
    {
        path: "/directory/boydenians/profile",
        name: "_userProfile",
        component: () => import("@/pages/profile/profile.vue"),
        meta: {
            title: "Your Profile"
        }
    },
    {
        path: "/directory/boydenians/report",
        name: "_ReportsUsers",
        component: () => import("@/pages/mcl/reports/users.vue"),
        meta: {
            title: "Boydenian Report",
            hideDrawer: true
        }
    },
    {
        path: "/directory/locations",
        name: "_Locations",
        component: () => import("@/pages/directory/locations.vue"),
        meta: {
            title: "Locations",
            hideDrawer: true
        }
    },
    {
        path: "/directory/location/:Id",
        name: "_locationDetail",
        component: () => import("@/pages/location/location.vue"),
        meta: {
            title: "Location"
        },
        props: route => ({
            locationId: route.params.Id
        })
    },
    {
        path: "/directory/licenses",
        name: "_Licenses",
        component: () => import("@/pages/directory/licenses.vue"),
        meta: {
            title: "Licenses",
            hideDrawer: true
        }
    },
    {
        path: "/directory/license/:Id",
        name: "_licenseDetail",
        component: () => import("@/pages/license/license.vue"),
        meta: {
            title: "License",
            hideDrawer: true
        },
        props: route => ({
            licenseId: route.params.Id
        })
    },
    {
        path: "/directory/locations/report",
        name: "_ReportsLocations",
        component: () => import("@/pages/mcl/reports/locations.vue"),
        meta: {
            title: "Location Report",
            hideDrawer: true
        }
    },
    {
        path: "/learn",
        name: "_learnMore",
        component: () => import("@/pages/learnMore.vue"),
        meta: {
            title: "Learn More"
        }
    },
    {
        path: "/report/:stub",
        name: "_reportRedirect",
        component: () => import("@/pages/report.vue"),
        meta: {
            title: "Loading Report"
        }
    },
    {
        path: "/daxtra",
        name: "_daxtraLanding",
        component: () => import("@/pages/daxtra.vue"),
        meta: {
            title: "Daxtra AI Search"
        }
    }
];
const getLocalRoutes = (router, forceUpdate) => {
    const storedRoutes = store.getters.localRoutes;
    if (!forceUpdate && storedRoutes && storedRoutes.length > 0) {
        return storedRoutes;
    }
    const normalized = localRoutesRaw.map(o => {
        if (o.path.includes(":"))
            return undefined;
        const location = {
            name: o.name,
            path: o.path
        };
        return router.resolve(location);
    }).filter((o) => o != null);
    store.dispatch("setLocalRoutes", normalized);
    return normalized;
};
const evaluateString = (s, route) => {
    const matches = s.match(/{{.*?}}/g);
    if (!matches)
        return s;
    let title = s;
    const buffer = [];
    for (let i = 0; i < matches.length; i++) {
        buffer[i] = [matches[i], matches[i].replace("{{", "").replace("}}", "").trim()];
        const paramName = buffer[i][1];
        const paramValue = route.params[paramName];
        title = title.replace(buffer[i][0], paramValue);
    }
    return title;
};
const findChildRecord = (route, name) => {
    if (route.VueRouterName && route.VueRouterName === name)
        return route;
    if (route.Children) {
        for (const child of route.Children) {
            const r = findChildRecord(child, name);
            if (r)
                return r;
        }
    }
    return false;
};
const findRecordByUUID = (route, uuid) => {
    if (route.UUID && route.UUID === uuid)
        return route;
    if (route.Children) {
        for (const child of route.Children) {
            const r = findRecordByUUID(child, uuid);
            if (r)
                return r;
        }
    }
    return false;
};
const _isObject = (obj) => {
    return obj instanceof Object && obj.constructor === Object;
};
const _extractParams = (s) => {
    const matches = s.match(/:[^\d]\w+/g);
    if (!matches)
        return [];
    const params = [];
    for (const match of matches) {
        const param = match.substring(1);
        params.push(param);
    }
    return params;
};
const _normalize = (item) => {
    if (item === undefined || item === null)
        return true;
    if (_isObject(item)) {
        for (const key of Object.keys(item)) {
            const value = item[key];
            if (value && key === "VueRouterPath") {
                const params = _extractParams(value);
                if (params.length > 0) {
                    item._params = params;
                }
            }
            else {
                if (_normalize(value)) {
                    delete item[key];
                }
                else {
                    if (value === "0") {
                        item[key] = false;
                    }
                    else if (value === "1") {
                        item[key] = true;
                    }
                }
            }
        }
    }
    else if (Array.isArray(item)) {
        for (const child of item) {
            _normalize(child);
        }
    }
    return false;
};
const _addIcons = (routes) => {
    for (const child of routes) {
        switch (child.VueRouterName) {
            case "apps":
                child._icon = {
                    type: "fas",
                    name: "th"
                };
                break;
            case "boyden":
                child._icon = {
                    type: "file",
                    src: "boyden_circle.svg"
                };
                break;
            case "mcl":
                child._icon = {
                    type: "fas",
                    name: "chart-bar"
                };
                break;
            case "directory":
                child._icon = {
                    type: "fas",
                    name: "users"
                };
                break;
            case "practices":
                child._icon = {
                    type: "fas",
                    name: "window-restore"
                };
                break;
            case "guides":
                child._icon = {
                    type: "fas",
                    name: "presentation"
                };
                break;
            case "initiatives":
                child._icon = {
                    type: "fas",
                    name: "bullhorn"
                };
                break;
        }
    }
};
const collapseRoutes = (routes) => {
    let collapsed = [];
    routes.forEach(r => {
        const _r = { ...r };
        const children = r.children;
        delete _r["children"];
        collapsed.push(_r);
        if (children && children.length > 0) {
            collapsed = collapsed.concat(collapseRoutes(children));
        }
    });
    return collapsed;
};
const getRoutes = async () => {
    const response = await Axios.get("api/v2/routes", { baseURL: process.env.VUE_APP_API });
    const routes = response.data;
    routes.forEach(child => {
        _normalize(child);
    });
    _addIcons(routes);
    store.dispatch("setRoutes", routes);
    return routes;
};
const buildRoutes = async () => {
    const root = [];
    const _flattenRoute = (routeObj, parentPath) => {
        const currentPath = parentPath + "/" + routeObj.VueRouterPath;
        root.push({
            component: () => import("@/pages/main.vue"),
            path: currentPath,
            name: routeObj.VueRouterName,
            meta: {
                title: routeObj.Title,
                breadcrumbTitle: routeObj.BreadcrumbTitle,
                uuid: routeObj.UUID,
                doNotOpen: !!routeObj.DoNotOpen,
                excludeFromNav: !!routeObj.ExcludeFromNav,
                hasFile: !!routeObj.HasFile,
                FileJSON: routeObj.FileJSON,
                redirectLink: routeObj.RedirectLink,
                downloadBtn: routeObj.DownloadBtn
            }
        });
        if (routeObj.Children && routeObj.Children.length > 0) {
            for (const child of routeObj.Children) {
                _flattenRoute(child, currentPath);
            }
        }
    };
    const remoteRoutes = await getRoutes();
    remoteRoutes.forEach(routeObj => {
        _flattenRoute(routeObj, "");
    });
    localRoutesRaw.forEach(routeObj => {
        root.push(routeObj);
    });
    const routes = [
        {
            path: "/",
            name: "mainTemplate",
            component: () => import(/* webpackChunkName: "mainTemplate" */ "@/pages/mainTemplate.vue"),
            children: root,
        },
        {
            path: "/admin",
            name: "adminTemplate",
            component: () => import(/* webpackChunkName: "mainTemplate" */ "@/pages/adminTemplate.vue"),
            children: [
                {
                    path: "routes",
                    name: "_adminRoutes",
                    component: () => import("@/pages/admin/routes.vue"),
                    meta: {
                        title: "Routes"
                    }
                }
            ]
        },
        {
            path: "/login",
            name: "login",
            component: () => import("@/pages/login.vue")
        },
        {
            path: "/noaccess",
            name: "noaccess",
            component: () => import("@/pages/noaccess.vue")
        }
    ];
    return routes;
};
const refreshRoutes = async () => {
    const router = store.getters.router;
    const routes = await buildRoutes();
    routes.forEach((r) => router.addRoute(r));
    router.replace({ name: router.currentRoute.name });
};
const getPathArray = (route) => {
    const fullPath = route.matched[route.matched.length - 1].path;
    const arr = fullPath.split("/");
    if (arr[0] === "") {
        arr.shift();
    }
    if (arr.length > 0 && arr[arr.length - 1] === "") {
        arr.pop();
    }
    return arr;
};
const getFullPathArray = (route, reusedPathArray) => {
    const pathArray = reusedPathArray ?? getPathArray(route);
    const newArray = [
        "/" + pathArray[0]
    ];
    for (let i = 1; i < pathArray.length; i++) {
        if (pathArray[i] !== "") {
            newArray[i] = newArray[i - 1] + "/" + pathArray[i];
        }
        else {
            break;
        }
    }
    return newArray;
};
const getRouteDetailArray = (route, routes) => {
    if (route.path === "/")
        return [];
    const pathArray = getPathArray(route);
    const fullPathArray = getFullPathArray(route, pathArray);
    const mainRoutes = routes.find((o) => {
        return o.name === "mainTemplate";
    })?.children;
    const newArray = [];
    for (let i = 0; i < pathArray.length; i++) {
        const path = pathArray[i];
        const fullPath = fullPathArray[i];
        if (i === pathArray.length - 1 && route.name.startsWith("_")) {
            newArray.push({
                name: route.name,
                title: route.meta?.title || "",
                path: route.path
            });
        }
        else {
            if (!mainRoutes)
                return [];
            const matchedRoute = mainRoutes.find((o) => {
                return o.path === fullPathArray[i];
            });
            if (matchedRoute) {
                const meta = matchedRoute.meta;
                newArray.push({
                    name: matchedRoute.name,
                    title: meta.title,
                    breadcrumbTitle: meta.breadcrumbTitle,
                    path: matchedRoute.path,
                    doNotOpen: meta.doNotOpen,
                    excludeFromNav: meta.excludeFromNav,
                    hasFile: meta.hasFile,
                    FileJSON: meta.FileJSON,
                    redirectLink: meta.RedirectLink,
                    downloadBtn: meta.DownloadBtn,
                });
            }
        }
    }
    return newArray;
};
const routeHasNullParams = (route) => {
    const keys = Object.keys(route.params);
    for (const key of keys) {
        if (!route.params[key]) {
            return true;
        }
    }
    return false;
};
export { getLocalRoutes, getRoutes, buildRoutes, refreshRoutes, evaluateString, findChildRecord, findRecordByUUID, getPathArray, getRouteDetailArray, getFullPathArray, routeHasNullParams };
